/**
 * Cross-app routing helper for the Sterling suite.
 *
 * Every Sterling app deploys at `https://<slug>.sfcapps.com`. The suite
 * launcher uses this helper as the default `onNavigate` when the host
 * doesn't supply one of its own. Apps that need bespoke routing (e.g.
 * SPA-internal nav when `slug === currentApp`) should pass their own.
 */
export const STERLING_BASE_DOMAIN = 'sfcapps.com';
/** Production URL for a Sterling app slug. */
export function sterlingAppUrl(slug, baseDomain = STERLING_BASE_DOMAIN) {
    return `https://${slug}.${baseDomain}`;
}
/** Default cross-app navigation: full-page navigate to `https://<slug>.<base>`. */
export function sterlingNavigate(slug, baseDomain) {
    if (typeof window === 'undefined')
        return;
    window.location.assign(sterlingAppUrl(slug, baseDomain));
}
//# sourceMappingURL=navigate.js.map